import * as React from "react";
import { forwardRef, memo } from "react";
const SvgSe = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 10", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 10, fill: "#006aa7" }), /* @__PURE__ */ React.createElement("rect", { width: 2, height: 10, x: 5, fill: "#fecc00" }), /* @__PURE__ */ React.createElement("rect", { width: 16, height: 2, y: 4, fill: "#fecc00" }));
const ForwardRef = forwardRef(SvgSe);
const Memo = memo(ForwardRef);
export default Memo;
